<!-- 详情_tabs -->
<template>
  <div :class="{ tabs: true, tabsFixed: tabFixed }">
    <!--  tabs label -->
    <div :class="{ chapterTabs: true }">
      <div
        v-for="(item, index) in tabsList"
        @click="cutTab(index, item.label)"
        :class="{ active: tabSelected == index }"
        :key="index"
        v-show="tabsList.length == index + 1 && goodCourseFlag == false ? false : true"
      >
        <p>{{ item.name }}</p>
        <span></span>
      </div>
    </div>
    <!--  tab content -->
    <div
      class="tabContent"
      :class="[{ grayBg: activeName === 'fourth' }, { wxFoot: this.$root.$data.isApp }]"
    >
      <div v-if="activeName === 'first'">
        <div class="courseIntroduce" v-html="introduction.introduction"></div>
      </div>
      <div v-if="activeName === 'second'">
        <div v-if="!isFaceCourse">
          <!-- 试听 -->
          <AuditionList
            v-show="containCurriculumData.videoInfoRespVOS"
            :auditionWarrp="containCurriculumData"
          />
          <!-- 目录树 -->
          <CourseTree :treeNodeInit="containCurriculumData.courseNodes" />
          <EmptyData :emptyName="'tree'" v-if="!containCurriculumData.courseNodes" />
        </div>
        <div class="school" v-else>
          <img v-for="(item, index) in schoolImg" :key="index" :src="item" alt="" />
        </div>
      </div>
      <div v-show="activeName === 'third'">
        <TeacherIntroduceModule></TeacherIntroduceModule>
      </div>
      <div v-show="activeName === 'fourth'">
        <evaluationList @evaluationTotal="evaluationTotal" source="product" />
      </div>
      <!-- 好课推荐 -->
      <div
        v-if="
          activeName === 'five' && goodCourseFlag == true ? goodCourseFlag : activeName === 'five'
        "
        class="goodCourseContent"
      >
        <GoodCourse :goodcourseList="recommendDataList"></GoodCourse>
      </div>
    </div>
    <div class="vip-ad" @click="jumpVipAd" v-if="showVipAd && vipAdData.id">
      <img :src="vipAdData.images" alt="广告" />
    </div>
    <Foot :class="{ footActive: this.$root.$data.isSafari }" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EmptyData from '@/components/emptyData/emptyData.vue';
import GoodCourse from '@/pages/courseDetail/courseComponents/goodcourse.vue';
import { reqProducts, reqRecommendList, reqAdvertPlaying } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import { reqClassType } from '@/api/courseDetail';

// eslint-disable-next-line import/extensions
import evaluationList from '@/pages/learningGuidePage/evaluation/evaluationList';
import Foot from '@/components/foot/privacy.vue';
import {
  deepCopy,
  judgmentPlatform,
  handleJumpType,
  gioPlatform,
  gioJumpType,
} from '@/utils/tools';
import TeacherIntroduceModule from '../../components/courseDetail/teacherIntroduceModule/TeacherIntroduceModule.vue';
import CourseTree from '../../components/course/CourseTree.vue';
import AuditionList from './courseComponents/auditionList.vue';

export default {
  data() {
    return {
      tabsList: [
        { name: '课程介绍', label: 'first' },
        { name: '课程目录', label: 'second' },
        { name: '师资介绍', label: 'third' },
        { name: '评价', label: 'fourth' },
        { name: '好课推荐', label: 'five' },
      ],
      activeName: 'first', // 当前选中的tab
      tabSelected: 0, // 被选中的tab
      introduction: {}, // 课程介绍
      productIdList: [], // 好课推荐课id list
      recommendDataList: [], // 好课推荐课data list
      goodCourseFlag: false,
      isFaceCourse: false,
      schoolImg: [], // 校区介绍
      showVipAd: false,
      vipAdData: {}, // VIP广告位数据（h5003）
      lastTime: null, // 广告点击节流
    };
  },
  props: ['tabFixed'],
  components: {
    TeacherIntroduceModule,
    CourseTree,
    AuditionList,
    GoodCourse,
    evaluationList,
    Foot,
    EmptyData,
  },
  watch: {
    courseBaseData(data) {
      this.checkFaceCourse();
      if (data && data.productIntroductionRespVOList) {
        this.introduction = data.productIntroductionRespVOList.find(
          (ele) => ele.terminalType === 2,
        );
      }
    },
    vipAdData: {
      handler(val) {
        if (val?.id) {
          this.gioEvent(val, 2);
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(['courseBaseData', 'containCurriculumData', 'buyStatus']),
  },
  created() {
    this.getVipAd();
  },
  mounted() {
    this.getRecommendList();

    document.body.addEventListener('click', (event) => {
      event.stopImmediatePropagation();
      // 兼容处理
      const { target } = event;
      const parentNodeName = target.parentNode.nodeName;
      // 判断是否匹配目标元素
      if (parentNodeName.toLocaleLowerCase() === 'a') {
        // 对捕获到的 a 标签进行处理，需要先禁止它的跳转行为
        if (event.preventDefault) {
          event.preventDefault();
        } else {
          window.event.returnValue = true;
        }

        // 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
        const url = target.parentNode.getAttribute('href');

        if (this.$root.$data.isApp) {
          const name = url?.substring(url?.lastIndexOf('.') + 1);
          if (judgmentPlatform() === 'android' && name === 'pdf') {
            this.$sendToApp('openBrowser', { url }, false);
          } else {
            this.$sendToApp('openNewWebView', { url }, false);
          }
          return;
        }
        if (target.parentNode.getAttribute('target') === '_blank') {
          window.open(url);
        } else {
          window.location.href = url;
        }
      }
    });
  },

  methods: {
    checkFaceCourse() {
      const { productCategoryName, productAttributeRespVOS } = this.courseBaseData;
      // eslint-disable-next-line no-unused-expressions
      (productAttributeRespVOS || []).forEach((element) => {
        if (element.extendAttributeNameEn === 'learningEn') {
          this.schoolImg = JSON.parse(element.dataJson || '[]');
        }
        if (element.extendAttributeNameEn === 'classType' && this.$root.miniprogram) {
          reqClassType().then((data) => {
            const status = data?.data.find((ele) => ele.value === element.dataJson);
            this.$root.setMiniProgramBuy(status);
          });
        }
        if (element.extendAttributeNameEn === 'classType') {
          this.showVipAd = !!(element.dataJson == 2);
        }
      });
      if (productCategoryName?.indexOf('线下课程') > -1) {
        this.isFaceCourse = true;
        if (!this.schoolImg.length) {
          this.tabsList.splice(1, 1);
          return;
        }
        const idx = 1;
        this.tabsList[idx] = {
          name: '校区介绍',
          label: 'second',
        };
      }
      if(this.$root.zsbMini){
        this.tabsList.splice(3, 1);
      }
      
    },
    evaluationTotal(val) {
      this.tabsList.forEach((item) => {
        if (item.name === '评价' && val > 0) {
          if (val > 99) {
            // eslint-disable-next-line no-param-reassign
            item.name = '评价(99+)';
          } else {
            // eslint-disable-next-line no-param-reassign
            item.name = `评价(${val})`;
          }
        }
      });
    },
    // 切换tab
    cutTab(index, label) {
      this.activeName = label;
      this.tabSelected = index;
    },
    /** 好课推荐** */
    // 通过产品id获取课程推荐
    async getRecommendList() {
      const res = await reqRecommendList(this.$route.query.courseId);
      if (res.code === 0) {
        if (res.code === 0 && res?.data?.recommendContentVOList) {
          this.productIdList = res.data.recommendContentVOList;
          this.getProducts();
        }
      }
    },
    // eslint-disable-next-line
    async getProducts() {
      const allProductIds = [];
      const allPackageIds = [];
      this.productIdList.forEach((child) => {
        const { productId, recommendType } = child;
        if (recommendType === 0) {
          allProductIds.push(productId);
        } else {
          allPackageIds.push(productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = allProductIds.length ? await reqProducts(allProductIds, endPoint) : {};
      const res1 = allPackageIds.length ? await reqCombinationlist(0, endPoint, allPackageIds) : {};
      const resCourse = this.resetCourse(res.data || []);
      const resPackage = this.resetCoursePackage(res1.data || []);
      const allCourse = [];
      this.productIdList.forEach((child) => {
        const findRes = [...resCourse, ...resPackage].find((course) => {
          const id = child.recommendType === 0 ? course.productId : course.packageId;
          return id === child.productId;
        });
        // eslint-disable-next-line no-unused-expressions
        findRes && allCourse.push(findRes);
      });
      this.recommendDataList = allCourse;
      this.goodCourseFlag = !!allCourse.length;
    },
    resetCourse(recommendDataList) {
      recommendDataList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice:
              productDiscountRespVO.discountMinPrice > item.sellPrice
                ? (
                    Number(productDiscountRespVO.discountMinPrice) +
                    Number(productDiscountRespVO.discountAmount)
                  ).toFixed(2)
                : item.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return recommendDataList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    jumpCourseDetail(courseInfo) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail ', { courseId: courseInfo.productId }, false);
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: courseInfo.productId,
        },
      });
    },
    // VIP广告位
    async getVipAd() {
      const res = await reqAdvertPlaying(['h5003']);
      if (res.code === 0 && res?.data) {
        this.vipAdData = res?.data?.find((item) => item.adCode === 'h5003')
          ?.advertisingContentWebInfoRespVOS?.[0] || {};
      }
    },
    jumpVipAd() {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent(this.vipAdData, 1);
      this.lastTime = Date.now();
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      handleJumpType(this, this.vipAdData);
    },
    gioEvent(item, type) {
      const { title, skipType } = item;
      const adId = item.id;
      if (!adId) return;
      if (type === 1) {
        // 点击广告
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: '课程详情-VIP广告', // 广告位置
          pageName_var: '课程详情', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: '课程详情-VIP广告', // 广告位置
          pageName_var: '课程详情', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType) || null, // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot {
  position: relative;
  bottom: auto;
  z-index: 1;
}
::v-deep .footActive.common-foot {
  padding-bottom: 220px;
}
.tabs {
  position: relative;
  background: #fff;
  $pubColor: #ff6c02;
  .chapterTabs {
    /* tabs label */
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 94px;
    background: #fff;
    border-bottom: 2px solid rgba(120, 120, 120, 0.2);
    border-radius: 14px 14px 0 0;
    > div {
      position: relative;
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #fff;
      p {
        width: 100%;
        color: #333;
        font-weight: 500;
        font-size: 29px;
        text-align: center;
        border-right: 2px solid #edf1f6;
      }
    }
    .active {
      /* 被选中状态 */
      > p {
        color: $pubColor;
      }
      &::before {
        position: absolute;
        bottom: 0;
        width: 45px;
        height: 5px;
        background-color: $pubColor;
        content: ' ';
      }
    }
    > div:last-child {
      p {
        border: none;
      }
    }
  }
  .tabContent {
    /* tab content */
    width: 100%;
    min-height: calc(100vh - 600px);
    // padding: 36px 36px 100px 36px;
    // padding-bottom: 120px;
    background-color: #fff;
    .goodCourseContent {
      background: #f9f9f9;
    }
    .courseIntroduce {
      width: 100%;
      padding: 36px;
      font-size: 28px;
      ::v-deep img {
        width: 100%;
      }
    }
    .evaluation-tab {
      .evaluation-list-page {
        min-height: calc(100vh - 216px);
      }
    }
  }

  .grayBg {
    background: #f9f9f9;
  }

  .evaluation-list-page {
    min-height: calc(100vh - 334px);

    ::v-deep .van-pull-refresh {
      min-height: calc(100vh - 5.41rem);
    }

    ::v-deep .emptyIndent {
      height: calc(100vh - 380px);
    }
  }
}
.tabsFixed {
  .chapterTabs {
    position: fixed;
    top: 0;
    z-index: 9;
  }
  .tabContent {
    margin-top: 94px;
  }
}
::v-deep .emptyIndent .hide {
  display: none;
}
.school {
  // padding: 40px;
  img {
    width: 100%;
  }
}

.wxFoot {
  padding-bottom: 100px;
}
.vip-ad {
  position: fixed;
  bottom: 120px;
  left: 0;
  z-index: 100;
  width: 100%;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
